export enum WorkflowAccessLevel {
  Public = 'Public',
  PublicForm = 'Public Form',
  Internal = 'Internal'
}
